import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;    // "order", "date", or "product"
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  vendor_from?: string;
  vendor_to?: string;
  product_from?: string;
  product_to?: string;
  dept_from?: string;
  dept_to?: string;
}

export interface ReportRow {
  FD140_01: string;      // order no
  FD140_12: string;      // order date
  FD140_10: string;      // vendor code
  vendor_name: string;
  FD140_181: string;     // product code 1
  FD140_182: string;     // product code 2
  product_code: string;  // concatenated
  FD140_11: string;      // outsource no
  FD141_02: number;      // detail seq
  FD141_11: string;      // work fee code
  FD130_15: string;      // work fee desc
  FD141_12: string;      // color code
  color_desc: string;    // color description
  FD141_13: string;      // unit
  FD141_14: number;      // unit price
  FD141_15: number;      // qty
  FD141_16: number;      // amount
  FD140_20: number;      // input qty
  FD140_14: number;      // shrink rate
  dept_code: string;
  dept_name: string;
}

export interface VendorCount {
  code: string;
  name: string;
  count: number;
}

export interface UnitSummary {
  FD141_13: string;   // unit
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  group_counts: VendorCount[];
  unit_summary: UnitSummary[];
  message?: string;
}

export const d304Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d304/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d304/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
